<div [attr.data-cy]="'customer-switcher-' + loggedInUser?.customerId">
  <mat-spinner
    diameter="24"
    *ngIf="isSwitching"
    class="customer-switching-spinner"
    data-cy="customer-switching-spinner"></mat-spinner>
  <ng-container *ngIf="!isSwitching">
    <input
      class="customer-switcher-input"
      name="userInput"
      [formControl]="customerInput"
      [matAutocomplete]="autoUsers"
      (focus)="onFocus()"
      data-cy="customer-autocomplete" />
    <button
      mat-button
      *ngIf="customerInputValue | async"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      (click)="clearCustomerInput($event)">
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </ng-container>
</div>

<mat-autocomplete
  #autoUsers="matAutocomplete"
  (optionSelected)="matInputSelect($event)">
  <mat-option
    *ngFor="let option of customerOptions$ | async"
    [value]="option.customer._id"
    [title]="option.formattedName"
    [attr.data-cy]="'customer-select-option-' + option.customer._id">
    {{ option.formattedName }}
  </mat-option>
</mat-autocomplete>
